import { isSchemaRecord } from './runtime-values.js';
import type { SchemaInput } from './schema-input.js';

export const MAGIC_LINK_FAILURE_REASONS = new Set([
  'invalid_email', 'disposable_email', 'invalid_context', 'rate_limited',
  'delivery_failed', 'service_unavailable', 'request_rejected', 'network_error',
] as const);

export function magicLinkFailureReason(status: number, payload: SchemaInput) {
  if (status === 429) return 'rate_limited';
  const error = isSchemaRecord(payload) ? payload.error : null;
  if (status === 400) {
    if (error === 'Invalid email') return 'invalid_email';
    if (error === 'Please use a permanent email address') return 'disposable_email';
    if (error === 'Invalid sign-in context') return 'invalid_context';
  }
  if (status === 502 && error === 'Failed to send email') return 'delivery_failed';
  return status >= 500 ? 'service_unavailable' : 'request_rejected';
}
